import { render, staticRenderFns } from "./AddTag.vue?vue&type=template&id=238f11c0&scoped=true&"
import script from "./AddTag.vue?vue&type=script&lang=js&"
export * from "./AddTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238f11c0",
  null
  
)

export default component.exports